<script>
import {queryServiceClientFile} from '@/apis/order'
import {downFile,fileSize,iconClass} from '@/apis/common'
import {publicDeleteFile} from '@/apis/file'
import simplebar from "simplebar-vue"
import vue2Dropzone from "vue2-dropzone"
export default {
  components: { simplebar,vueDropzone: vue2Dropzone},
  props:{
    serviceId:{
      type: String,
      required: true
    },
    serviceStatus:{
      type: String,
      required: true
    },serviceType:{
      type: String,
      required: false
    },    
  },
  data() {
    return {
      uploadFileList:[],
      clientFileList:[],
      preAuditFileList:[],
      form:{
        fileName:"",
      },      
      fileOrgName:"",
      success:false,
      error:false,
      errorMsg:"",
      dropzoneOptions: {
        url: "/api-gateway/service/publicUpload",
        thumbnailWidth: 80,
        maxFilesize: 100,
        addRemoveLinks: true,
        paramName:"files",
      },
    };
  },
  mounted() {
    this.loadData();
  },
  computed:{
    showNote(){
      if(this.serviceType!=null && this.serviceType.indexOf("Higg")!=-1){
        return true
      }else{
        return false
      }
    },
    showUpload(){
      if(this.error) return false;
      let statuses = ["F"]
      if(statuses.includes(this.serviceStatus)){
        return false;
      }else{
        return true;
      }
    }
  },
  methods: {
    formatStatus(status){
      if(status==null || status==""){
        return "待审"
      }else if(status=="Y"){
        return "通过"
      }else if(status=="N"){
        return "不通过"
      }
      return ""
    },
    handleDownload (item){
        const url=`/api-gateway/service/download?fileType=SERVICE&fileName=${item.fileOrgName}`
        downFile(url,item.fileName);
    },
    handleDelete(fileName){
      this.clientFileList.forEach((item, index) => {
        if (item.fileOrgName==fileName) {
          publicDeleteFile({"id":this.serviceId,"type":"preAuditFile",fileName:fileName}).then((res)=>{
            if(res.data){
              this.clientFileList.splice(index, 1);
            }
          });         
        }
      });
    },
    handlerFileSending: function (file, xhr, formData) {
        formData.append("type","preAuditFile")
        formData.append("id",this.serviceId)
    },
    // eslint-disable-next-line no-unused-vars
    handlerFileSendingComplete: function (file, xhr, formData) {
        let uploadFile = JSON.parse(file.xhr.response).data[0]
        this.clientFileList.push(uploadFile)
        this.uploadFileList.push(file)
    },
    removeUploadFile(file){
      let uploadFile = JSON.parse(file.xhr.response).data[0]
      this.handleDelete(uploadFile.fileOrgName)
    },
    loadData(){
      queryServiceClientFile(this.serviceId,2).then((res)=>{
        this.clientFileList = res.data
      }) 
    },
    fileSize,
    iconClass
  },
};
</script>

<template>
  <div>
    <div v-if="showNote">
      {{$t('verfDocument.preTitle')}}：
      <ol  v-html="$t('verfDocument.pre1')">
      </ol>
    </div>
    <div class="card-body" v-if="clientFileList.length>0">
      <div class="table-responsive">
          <simplebar class="h-100">
              <table class="table align-middle table-nowrap table-hover mb-0">
                  <thead class="table-light">
                      <tr>
                        <th scope="col">{{$t("verfDocument.file")}}</th>
                          <th scope="col">{{$t("verfDocument.status")}}</th>
                          <th scope="col">{{$t("verfDocument.comments")}}</th>
                          <th scope="col">{{$t("verfDocument.updateTime")}}</th>
                          <th scope="col" colspan="2">{{$t("verfDocument.size")}}</th>
                      </tr>
                      </thead>
                  <tbody>
                      <tr v-for="item in clientFileList" :key="item.fileOrgName">
                          <td><a @click="handleDownload(item)" href="javascript:" class="text-dark fw-medium"><i class="mdi font-size-16 align-middle me-2" :class="iconClass(item.fileName)"></i> {{item.fileName}}</a></td>
                          <td>{{formatStatus(item.status)}}</td>
                          <td>{{item.comments}}</td>
                          <td>{{item.updateDate}}</td>
                          <td>{{fileSize(item.size)}}</td>
                          <td>
                              <a  @click="handleDownload(item)" href="javascript:">{{$t("common.download")}}</a>
                              <a  @click="handleDelete(item.fileOrgName)" href="javascript:" class="ms-2" v-if="showUpload">{{$t("common.delete")}}</a>
                          </td>
                      </tr>
                  </tbody>
              </table>
          </simplebar>
      </div>
    </div>
    <div class="card-body" v-if="showUpload">
      <div class="col-lg-12 col-sm-12">
        <h4 class="card-title">{{$t("common.uploadFile")}}</h4>
        <div class="mb-5">
        <!-- file upload -->
        <vue-dropzone id="dropzone" ref="myVueDropzone" :options="dropzoneOptions"
        @vdropzone-sending="handlerFileSending"
        @vdropzone-complete="handlerFileSendingComplete"
        @vdropzone-removed-file="removeUploadFile"
        ></vue-dropzone>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.is-invalid .mx-input-wrapper .mx-input{
    border: 1px solid #ec4561 !important;
  }
  .is-invalid .mx-input-wrapper .mx-icon-calendar{
    color: #ec4561 !important;
  }
</style>
